import { Routes } from "@angular/router";
import { CanActivateHomePageGuard } from "./core/guards/can-activate-home-page.guard";
import { CanActivateMenuPageGuard } from "./core/guards/can-activate-menu-page.guard";
import { CanDeactivateMenuPageGuard } from "./core/guards/can-deactivate-menu-page.guard";
import { RouteResolver } from "./core/helpers/route-resolver";
import { LayoutAppComponent } from "./core/layout/layout-app/layout-app.component";
import { LayoutLoginComponent } from "./core/layout/layout-login/layout-login.component";

export const APP_ROUTES: Routes = [
  { path: "", redirectTo: "empresa-nao-encontrada", pathMatch: "full" },
  {
    path: "empresa-nao-encontrada",
    loadChildren: () =>
      import("./pages/company-not-found/company-not-found.module").then(
        (m) => m.CompanyNotFoundPageModule,
      ),
  },
  // Absolute: a relative child redirect becomes /:friendly-name/produtos/app/produtos and hits **.
  {
    path: ":friendly-name/produtos",
    redirectTo: "/:friendly-name/app/produtos",
    pathMatch: "full",
  },
  {
    path: ":friendly-name",
    resolve: { resolve: RouteResolver },
    children: [
      {
        path: "",
        component: LayoutLoginComponent,
        children: [
          {
            path: "",
            redirectTo: "login",
            pathMatch: "full",
          },
          {
             path: "login",
            loadComponent: () =>
              import("./pages/waiter-login/waiter-login.page").then(
                (m) => m.WaiterLoginPage,
              ),
          },
          {
            path: "comandaemesa",
            canActivate: [CanActivateHomePageGuard],
            loadComponent: () =>
              import("./pages/select-order/select-order.page").then(
                (m) => m.SelectOrderPage,
              ),
          },
        ],
      },
      {
        path: "app",
        canActivate: [CanActivateMenuPageGuard],
        canDeactivate: [CanDeactivateMenuPageGuard],
        component: LayoutAppComponent,
        children: [
          {
            path: "",
            redirectTo: "produtos",
            pathMatch: "full",
          },
          // Dialog de detalhe só altera a URL via pushState; no reload volta ao cardápio.
          {
            path: "produtos/detalhes",
            redirectTo: "produtos",
            pathMatch: "full",
          },
          {
            path: "produtos",
            loadComponent: () =>
              import("./pages/products/products.page").then(
                (m) => m.ProductsPage,
              ),
          },
          {
            path: "pedidos",
            loadComponent: () =>
              import("./pages/ordercheck-history/ordercheck-history.page").then(
                (m) => m.OrderCheckHistoryPage,
              ),
          },
        ],
      },
      {
        path: "carrinho",
        canActivate: [CanActivateMenuPageGuard],
        loadComponent: () =>
          import("./pages/order-cart/order-cart.component").then(
            (m) => m.OrderCartComponent,
          ),
      },
      // Absolute: relative redirect would become /:friendly-name/empresa-nao-encontrada and loop on **.
      { path: "**", redirectTo: "/empresa-nao-encontrada" },
    ],
  },
  { path: "**", redirectTo: "empresa-nao-encontrada" },
];
